import { API_URL } from './constants';
import { GeneratePostDto, GeneratePostResponse } from './types/blog-automation';

export async function apiBlogAutomationGenerate(
  body: GeneratePostDto,
  token: string,
): Promise<[GeneratePostResponse, number]> {
  const url = new URL(`${API_URL}/admin/blog-automation/generate`).href;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  return [await response.json(), response.status];
}
